// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
    <sub-header header="'End the day for branch ' + \$ctrl.branchName"></sub-header>


    <div class="alert" ng-if="\$ctrl.bankHoliday || \$ctrl.branchHoliday">
      <span>
        Tomorrow is a holiday
        <ul>
          <li ng-if="\$ctrl.bankHoliday">Bank: {{\$ctrl.bankHoliday.name}}</li>
          <li ng-if="\$ctrl.branchHoliday">Branch: {{\$ctrl.branchHoliday.name}}</li>
        </ul>
      </span>
    </div>

    <div class="alert"
         ng-if="\$ctrl.autoCcAndSod && (\$ctrl.branch.automaticCloseCounter || \$ctrl.branch.automaticStartDay)">
      <span>
        The following actions will be executed automatically:
        <ul>
          <li ng-if="\$ctrl.branch.automaticCloseCounter">Close counter</li>
          <li ng-if="\$ctrl.branch.automaticStartDay">Start the day</li>
        </ul>
      </span>
    </div>

    <!-- Product mapping validation -->
    <span ng-if="!\$ctrl.validateMappingsStatus()">
      <h2 class="misc-transaction__error-title">End of day process cannot be performed due to following misconfiguration</h2>
      <table class="misc-transaction-listing__table table">

        <!-- Header -->
        <thead>
        <tr>
          <th></th>
          <th>Product type name</th>
          <th class="centered">Affected products count</th>
          <th class="centered">Missing GL mappings</th>
          <th></th>
        </tr>
        </thead>

        <!-- Steps -->
        <tbody>
        <tr ng-repeat="mapping in \$ctrl.blockingProductMappings">
          <td>{{\$index + 1}}.</td>
          <td>{{\$ctrl.getProductDefinition(mapping.productDefinitionId).productName}}</td>
          <td class="centered">{{mapping.productCount}}</td>
          <td class="error centered">{{mapping.misconfiguredCount}}</td>
          <td></td>
        </tr>
        </tbody>
      </table>
    </span>

    <span ng-if="\$ctrl.hasFailedHC">
      <h2 class="misc-transaction__error-title">End of Day cannot be performed due to the following failed health checks:</h2>

      <span ng-if="\$ctrl.hasFailingCloseCounterHc">
        <h3 class="misc-transaction__error-title">For Close Counter</h3>
        <health-check-list checks="\$ctrl.failedHcForCloseCountersPhase" phase-type="'CLOSE_COUNTERS'" hide-ok="true"></health-check-list>
      </span>

      <span ng-if="\$ctrl.hasFailingHealthCheckHc">
        <h3 class="misc-transaction__error-title">For End of Day</h3>
        <health-check-list checks="\$ctrl.failedHcForHeathCheckPhase" phase-type="'HEALTH_CHECK'" hide-ok="true"></health-check-list>
      </span>
    </span>

    <!-- Batch process steps -->
    <div ng-if="\$ctrl.validateMappingsStatus() && (\$ctrl.ignoreHealthCheck || !\$ctrl.hasFailedHC)">
      <h2 class="section-header">End the day for branch {{ \$ctrl.branchName }}</h2>
      <table class="misc-transaction-listing__table table">

        <!-- Header -->
        <thead>
        <tr>
          <th></th>
          <th>System will execute following actions:</th>
          <th></th>
          <th></th>
        </tr>
        </thead>

        <!-- Steps -->
        <tbody>
        <tr ng-repeat="step in \$ctrl.stepStatuses" ng-if="\$ctrl.stepStatuses">
          <td>{{\$index + 1}}.</td>
          <td>{{step.name | translate:'END_THE_DAY'}}</td>
          <td></td>
          <td>{{step.status ? step.status : 'PENDING' | prettyEnum}}</td>
        </tr>
        </tbody>
      </table>

      <!-- Buttons panel -->
      <form>
        <div class="buttons">
          <button
            class="misc-transaction__cancel btn btn-warning"
            ng-click="\$ctrl.cancelChanges()">
            Exit
          </button>
          <button
            type="submit"
            class="misc-transaction__save btn"
            ng-class="{'btn-success' : \$ctrl.endOfDayEnabled(), 'btn-disabled' : !\$ctrl.endOfDayEnabled()}"
            ng-disabled="!\$ctrl.endOfDayEnabled()"
            ng-click="\$ctrl.save()">
            <i class="icon-spinner spinner" ng-if="\$ctrl.hasPendingEodJob || \$ctrl.refetchEnabled"></i>
            Start process
          </button>
        </div>
      </form>
    </div>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/miscellaneous-transactions/end-the-day/end-the-day.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;